import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { publicationInfoComponent } from './publicationInfo.component';
import { TranslateModule } from '@ngx-translate/core';

import { TableModule } from 'primeng-lts/table';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { CalendarModule } from 'primeng-lts/calendar';
import { CheckboxModule } from 'primeng-lts/checkbox';
import { DialogModule } from 'primeng-lts/dialog';
import { SelectButtonModule } from 'primeng-lts/selectbutton';

@NgModule({
  declarations: [publicationInfoComponent],
  imports: [
    TranslateModule,
    CommonModule,
    TableModule,
    FormsModule,
    DialogModule,
    CheckboxModule,
    CalendarModule,
    SelectButtonModule,
    RouterModule,
    FormPlycaModule
  ]
})
export class PublicationInfoModule { }
